import home from '../pages/home.vue';
import caseTmpl from '../pages/case.vue';
import worksTmpl from '../pages/works.vue';
import teamTmpl from '../pages/team.vue';
import serviceTmpl from '../pages/service.vue';
import cultureTmpl from '../pages/culture.vue';
import blogTmpl from '../pages/blog.vue';
import postTmpl from '../pages/post.vue';
import impressumTmpl from '../pages/impressum.vue';
import fourOfourTmpl from '../pages/404.vue';

export default [
  {
    label: 'Home',
    path: '/',
    component: home,
    exclude: true,
  },
  {
    label: 'Arbeiten',
    path: '/work',
    component: worksTmpl,
  },
  {
    label: 'Service',
    path: '/services',
    component: serviceTmpl,
  },
  {
    label: 'Team',
    path: '/team',
    component: teamTmpl,
  },
  {
    label: 'Culture',
    path: '/culture',
    component: cultureTmpl,
  },
  {
    name: 'work',
    path: '/work/:case',
    component: caseTmpl,
    exclude: true,
  },
  {
    label: 'Impact',
    path: '/impact',
    component: blogTmpl,
  },
  {
    name: 'post',
    path: '/blog/:post',
    component: postTmpl,
    exclude: true,
  },
  {
    name: 'impressum',
    label: 'Impressum',
    path: '/impressum',
    component: impressumTmpl,
    exclude: true,
  },
  {
    name: '404',
    path: '/:pathMatch(.*)*',
    component: fourOfourTmpl,
    exclude: true,
  },
];
